/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プラン変更承認依頼を却下する際にPOSTするBody
 * @export
 * @interface PostPlanChangeApprovalRequestRejectBody
 */
export interface PostPlanChangeApprovalRequestRejectBody {
    /**
     * 却下した時の承認担当者名
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestRejectBody
     */
    rejecterName: string;
    /**
     * 却下理由
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestRejectBody
     */
    rejectedReason: string;
}

export function PostPlanChangeApprovalRequestRejectBodyFromJSON(json: any): PostPlanChangeApprovalRequestRejectBody {
    return PostPlanChangeApprovalRequestRejectBodyFromJSONTyped(json, false);
}

export function PostPlanChangeApprovalRequestRejectBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPlanChangeApprovalRequestRejectBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rejecterName': json['rejecter_name'],
        'rejectedReason': json['rejected_reason'],
    };
}

export function PostPlanChangeApprovalRequestRejectBodyToJSON(value?: PostPlanChangeApprovalRequestRejectBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rejecter_name': value.rejecterName,
        'rejected_reason': value.rejectedReason,
    };
}

